import { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useAuth } from '../../context/AuthContext.jsx'

export default function UserHeaderChip() {
  const { user, logout } = useAuth()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)
  const navigate = useNavigate()

  const handleClickOutside = useCallback((e) => {
    if (ref.current && !ref.current.contains(e.target)) setOpen(false)
  }, [])

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [handleClickOutside])

  if (!user) return null

  const initials = (user.display_name || user.email || '?')
    .split(' ')
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()

  async function handleLogout() {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button type="button" className="userHeaderChip" onClick={() => setOpen((v) => !v)}>
        {user.avatar
          ? <img className="userHeaderAvatar" src={user.avatar} alt="" />
          : <span className="userHeaderAvatar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7rem', fontWeight: 600 }}>{initials}</span>
        }
        <span className="userHeaderName">{user.display_name || user.email}</span>
      </button>

      {open ? (
        <div className="userHeaderDropdown">
          <div className="userHeaderDropdownInfo">
            <p className="userHeaderDropdownEmail">{user.email}</p>
            <span className="userHeaderDropdownRole">{user.role}</span>
          </div>
          <button type="button" className="userHeaderDropdownItem userHeaderDropdownItemDanger" onClick={handleLogout}>
            Logout
          </button>
        </div>
      ) : null}
    </div>
  )
}
